import { useState, useRef, useEffect, } from "react";

import { useGoogleMap } from "@ubilabs/google-maps-react-hooks";

const Location = () => {
  const google = window.google;
  const [lat, setLat] = useState(53.6167727)
  const [lng, setLng] = useState(-6.2011085)
  const map = useGoogleMap();
  const markerRef = useRef();

  useEffect(() => {
    if (!map || markerRef.current) return;
    markerRef.current = new google.maps.Marker({map})
  }, [map]);
  useEffect(() => {
    if(!markerRef.current) return
    markerRef.current.setPosition({lat, lng})
  }, [lat, lng, map])

  return 
  
};

export default Location;
